var map = {
	"./arrow-down-blue.svg": 513,
	"./arrow-down-grey.svg": 514,
	"./arrow-right-white.png": 515,
	"./arrow-right.svg": 516,
	"./blue-loader.svg": 232,
	"./circle-grey.svg": 517,
	"./circle.svg": 518,
	"./coinbaseWalletIcon.png": 148,
	"./coinbaseWalletIcon.svg": 519,
	"./dropdown-blue.svg": 520,
	"./dropdown.svg": 521,
	"./dropup-blue.svg": 522,
	"./ethereum-logo.png": 523,
	"./fortmaticIcon.png": 524,
	"./link.svg": 525,
	"./logo.png": 145,
	"./magnifying-glass.svg": 526,
	"./matic-logo.png": 233,
	"./menu.svg": 527,
	"./metamask.png": 231,
	"./plus-blue.svg": 528,
	"./plus-grey.svg": 529,
	"./portisIcon.png": 530,
	"./question-mark.svg": 531,
	"./question.svg": 532,
	"./spinner.svg": 533,
	"./token-list-logo.png": 534,
	"./token-list/lists-dark.png": 535,
	"./token-list/lists-light.png": 536,
	"./trustWallet.png": 537,
	"./walletConnectIcon.png": 149,
	"./walletConnectIcon.svg": 538,
	"./x.svg": 539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 205;